import React, { Fragment } from 'react';
import Autocomplete from 'react-autocomplete';

import FIELDS from '../../../../data/fields';

export class AutoComplete extends React.PureComponent {
  render() {
    const {
      newClient = '', email = '', searched = '', extraClass = '',
    } = this.props;

    return (
      <Fragment>
        <div className={`form-group autocomplete-client ${extraClass}`}>
          {!newClient
            ? (
              <input
                type="text"
                className="form-control"
                disabled
                value={email}
                maxLength={FIELDS.max}
              />
            )
            : (
              <Autocomplete
                getItemValue={item => this.props.setSelectedContactGlobal(item)}
                items={searched || []}
                className="form-control custom-select autocomplete-custom z-index"
                renderItem={(item, isHighlighted) => (
                  <div style={{ background: isHighlighted ? 'lightgray' : 'white' }}>
                    {item.email}
                  </div>
                )}
                maxLength={FIELDS.max}
                value={email}
                onChange={e => this.props.setSearchOnChange(e.target.value)}
                onSelect={e => this.props.setSelectedSphereContact(e)}
                inputProps={{
                  onFocus: () => this.props.onFocus(),
                  onBlur: () => this.props.onBlur(),
                }}
              />
            )
              }

        </div>
      </Fragment>
    );
  }
}

export default {
  AutoComplete,
};
